var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news",on:{"click":_vm.onDetail}},[_c('p',[_vm._v(_vm._s(_vm.item.time))]),_vm._v(" "),_c('p',{staticClass:"mutline title"},[_vm._v("\n    "+_vm._s(_vm.item.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"mutline content"},[_vm._v("\n    "+_vm._s(_vm.item.introduce)+"\n  ")]),_vm._v(" "),_c('i',{staticClass:"more"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee5c2a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/homePage/components/news.vue
// module id = null
// module chunks = 